@if (parentalControlOptions && parentalControlOptions.length > 0) {
    <div class="row" checkoutCy="parental_control_block">
        <div class="column is-fullwidth is-narrow pr-0 pl-0">
            <div [formGroup]="parentalControlForm" class="box">
                <div class="has-text-left">
                    <div class="columns is-aligned-center">
                        <div class="column">
                            <p class="title is-level-5">
                                Cette ligne sera-t-elle utilisée par un mineur (-18 ans)&nbsp;?
                            </p>

                            <p class="text is-level-2 is-marginless">
                                Si oui, on vous conseille de le protéger des contenus sensibles avec le contrôle
                                parental
                            </p>
                        </div>
                        <div class="column is-narrow">
                            <div class="radios is-flex-nowrap is-horizontal-mobile">
                                <div class="radio-tile is-horizontal is-narrow-desktop is-marginless">
                                    <input
                                        checkoutCy="control_choice_yes"
                                        [value]="true"
                                        formControlName="choiceControl"
                                        id="control_choice_yes{{ quoteIndex }}"
                                        type="radio"
                                        [attr.disabled]="
                                            (parentalControlForm.get('choiceControl').value !== true &&
                                                !!waitForCartModifications) ||
                                            null
                                        "
                                    />
                                    <label for="control_choice_yes{{ quoteIndex }}" class="radio-label">
                                        <span><span class="radio-title">Oui</span></span>
                                    </label>
                                </div>
                                <div class="radio-tile is-horizontal is-narrow-desktop">
                                    <input
                                        checkoutCy="control_choice_no"
                                        [value]="false"
                                        formControlName="choiceControl"
                                        id="control_choice_no{{ quoteIndex }}"
                                        type="radio"
                                        [attr.disabled]="
                                            (parentalControlForm.get('choiceControl').value !== false &&
                                                !!waitForCartModifications) ||
                                            null
                                        "
                                    />
                                    <label for="control_choice_no{{ quoteIndex }}" class="radio-label">
                                        <span><span class="radio-title">Non</span></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    @if (showForm) {
                        <div class="row has-text-centered">
                            <div class="is-small has-body is-shadowless">
                                <div _ngcontent-smo-c134="" class="is-stretched block-element">
                                    <div _ngcontent-smo-c134="" class="divider has-background-info-fade"></div>
                                </div>
                                <div class="rows">
                                    <div class="row">
                                        <p class="text is-level-1 has-text-weight-semibold has-text-left">
                                            J’opte pour le contrôle parental
                                        </p>
                                    </div>
                                    <div class="row">
                                        @for (
                                            parentalOption of parentalControlOptions;
                                            track parentalOption;
                                            let i = $index
                                        ) {
                                            @if (parentalOption.isPremium) {
                                                <div class="radio-tile is-horizontal is-flex is-fullwidth">
                                                    <input
                                                        [checkoutCy]="
                                                            'fai_control_choice_' + parentalOption.option.gencode
                                                        "
                                                        [value]="parentalOption.option.gencode"
                                                        formControlName="parentalControl"
                                                        [attr.id]="parentalOption.option.gencode"
                                                        [attr.disabled]="waitForCartModifications"
                                                        type="radio"
                                                    />
                                                    <label
                                                        class="radio-label is-spaced-between is-fullwidth padding-top-normal has-text-left is-multiline"
                                                        [attr.for]="parentalOption.option.gencode"
                                                    >
                                                        <span>
                                                            <span class="radio-title">
                                                                @if (parentalOption.option.data.wording_promo) {
                                                                    <p class="has-text-info has-text-weight-semibold">
                                                                        Premium
                                                                    </p>
                                                                } @else {
                                                                    <p
                                                                        [ngClass]="{
                                                                            'is-invisible':
                                                                                parentalOption.option.data.price > 0,
                                                                        }"
                                                                        class="has-text-weight-semibold is-block"
                                                                    >
                                                                        Gratuit
                                                                    </p>
                                                                }
                                                            </span>
                                                            <span>
                                                                <p>
                                                                    <span>
                                                                        Protégez tous les appareils du foyer avec
                                                                        Qustodio.
                                                                    </span>
                                                                </p>
                                                            </span>
                                                        </span>
                                                        <span [ngClass]="isMobile ? '' : 'has-text-right'">
                                                            <span class="has-text-weight-semibold has-text-info">
                                                                {{ parentalOption.option.data.wording_promo }}
                                                            </span>

                                                            <span [ngClass]="isMobile ? '' : 'is-block'">
                                                                puis
                                                                <trg-price
                                                                    [hasPeriod]="true"
                                                                    [price]="parentalOption.option.data.price"
                                                                    [inheritFontSize]="true"
                                                                    [isInlined]="true"
                                                                />
                                                            </span>
                                                        </span>
                                                    </label>
                                                </div>
                                            } @else {
                                                <div class="radio-tile is-horizontal is-flex is-fullwidth">
                                                    <input
                                                        [value]="parentalOption.option.gencode"
                                                        formControlName="parentalControl"
                                                        [attr.id]="parentalOption.option.gencode"
                                                        [attr.disabled]="waitForCartModifications"
                                                        type="radio"
                                                    />
                                                    <label
                                                        class="radio-label is-spaced-between is-fullwidth padding-top-normal has-text-left is-multiline"
                                                        [attr.for]="parentalOption.option.gencode"
                                                    >
                                                        <span>
                                                            <span class="radio-title">
                                                                @if (parentalOption.option.data.wording_promo) {
                                                                    <p class="has-text-info has-text-weight-semibold">
                                                                        {{ parentalOption.option.data.wording_promo }}
                                                                    </p>
                                                                } @else {
                                                                    <p
                                                                        [ngClass]="{
                                                                            'is-invisible':
                                                                                parentalOption.option.data.price > 0,
                                                                        }"
                                                                        class="has-text-weight-semibold is-block"
                                                                    >
                                                                        Basique
                                                                    </p>
                                                                }
                                                            </span>
                                                            <p>Protégez 1 appareil de votre choix.</p>
                                                            @if (parentalOption.option.data.wording_promo) {
                                                                <span>
                                                                    à
                                                                    @if (parentalOption.option.data?.price > 0) {
                                                                        <trg-price
                                                                            [hasPeriod]="true"
                                                                            [price]="parentalOption.option.data?.price"
                                                                            [size]="'is-4'"
                                                                        />
                                                                    }
                                                                </span>
                                                            }
                                                        </span>
                                                        <span [ngClass]="isMobile ? '' : 'has-text-right'">
                                                            <span class="has-text-weight-semibold">Gratuit</span>
                                                        </span>
                                                    </label>
                                                </div>
                                            }
                                        }
                                        <div class="is-flex has-cursor is-fullwidth">
                                            <div class="radio-tile is-horizontal is-flex is-fullwidth">
                                                <input
                                                    value="parentalControl_no{{ quoteIndex }}"
                                                    formControlName="parentalControl"
                                                    attr.id="parentalControl_no{{ quoteIndex }}"
                                                    [attr.disabled]="waitForCartModifications"
                                                    type="radio"
                                                />
                                                <label
                                                    class="radio-label is-spaced-between is-fullwidth padding-top-normal has-text-left is-multiline"
                                                    attr.for="parentalControl_no{{ quoteIndex }}"
                                                >
                                                    <span>
                                                        <span class="radio-title">
                                                            <p class="has-text-weight-semibold is-block">
                                                                Non, pas de contrôle parental
                                                            </p>
                                                        </span>
                                                    </span>
                                                    <span [ngClass]="isMobile ? '' : 'has-text-right'">
                                                        <span class="has-text-weight-semibold"></span>
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}
